import { render } from "./ScreeningReport.vue?vue&type=template&id=f566c6f6&ts=true"
import script from "./ScreeningReport.vue?vue&type=script&lang=ts"
export * from "./ScreeningReport.vue?vue&type=script&lang=ts"

import "./ScreeningReport.vue?vue&type=style&index=0&id=f566c6f6&lang=scss"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__